// extracted by mini-css-extract-plugin
module.exports = {"root":"FieldCheckboxGroup_root__3YD0o","list":"FieldCheckboxGroup_list__3LxTw","twoColumns":"FieldCheckboxGroup_twoColumns__2k_J2","item":"FieldCheckboxGroup_item__2pqjy"};